import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

interface Props {
  count: number;
}

const MessagesIcon: React.FC<SvgIconProps & Props> = ({
  viewBox = '0 0 35 27.737',
  count,
  ...rest
}) => (
  <SvgIcon
    {...rest}
    viewBox={viewBox}
    style={{ width: 35, height: 27.737, ...rest.style }}
  >
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(-473 -642)">
      <g transform="translate(-2714.64 -1342.111)">
        <path
          fill="#224060"
          d="M3188.517,2011.821c.194.016.389.005.584.005h15.193v.022h5.011v-.022c.763,0,1.465,0,2.167,0,.912,0,1.169-.26,1.169-1.179V1996.36c0-.973-.238-1.206-1.229-1.208h-2.108v-.039h-5.022v.008c-.181.01-.367.03-.554.03q-7.367,0-14.735,0c-.15,0-.3-.006-.449.005a.852.852,0,0,0-.9.949q-.006,7.39,0,14.78A.85.85,0,0,0,3188.517,2011.821Zm2.252-1.721,5.948-5.948c.841.72,1.758,1.509,2.68,2.293.6.512.895.512,1.486.008.922-.786,1.841-1.574,2.713-2.32l5.967,5.967Zm20.191-12.281v10.917l-5.877-5.877Zm-1.431-.971-9.382,8.042-9.384-8.042Zm-20.183.984,5.931,5.084-5.931,5.931Z"
        />
      </g>
      <g transform="translate(243 402)">
        <circle
          fill="#f06950"
          cx="9.5"
          cy="9.5"
          r="9.5"
          transform="translate(246 240)"
        />
        <text
          fill="#fff"
          fontSize="12px"
          fontFamily="NeuzeitGro-Bol, Neuzeit Grotesk"
          transform="translate(252 245)"
        >
          <tspan x="0" y="9">
            {count > 9 ? '9+' : count}
          </tspan>
        </text>
      </g>
    </g>
  </SvgIcon>
);

export default MessagesIcon;
